import { apiRequests } from '../utilities/axios-factory'
import store from '../store'

function mapOcppIdTagAssignment (row) {
  if (!row) {
    return row
  }
  const metadata = row.metadata || {}
  return {
    id: row.id,
    idTag: row.id_tag || row.idTag,
    transportationProfileId: row.transportation_profile_id || row.transportationProfileId,
    transportationOwnerId: row.transportation_owner_id || row.transportationOwnerId,
    status: row.status,
    vehicleClass: row.vehicle_class || row.vehicleClass,
    fingerprintStatus: row.fingerprint_status || row.fingerprintStatus,
    metadata,
    assignmentNotes: metadata.assignmentNotes || '',
    dateCreated: row.date_created || row.dateCreated,
    dateUpdated: row.date_updated || row.dateUpdated,
    licensePlateNumber: row.license_plate_number || row.licensePlateNumber,
    shortcodeId: row.shortcode_id || row.shortcodeId,
    transportType: row.transport_type || row.transportType,
    transportationOwnerName: row.transportation_owner_name || row.transportationOwnerName
  }
}

function listOcppIdTags ({ transportationProfileId }) {
  return apiRequests.get('/v1/ocpp-id-tag/profile-assignments', {
    params: {
      transportationProfileId: transportationProfileId || undefined,
      limit: 100,
      offset: 0,
      order: 'id_tag ASC'
    },
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => (result.data || []).map(mapOcppIdTagAssignment))
}

function listOcppIdTagAssignments ({ transportationProfileId, search, limit, offset, order } = {}) {
  return apiRequests.get('/v1/ocpp-id-tag/profile-assignments', {
    params: {
      transportationProfileId: transportationProfileId || undefined,
      search: search || undefined,
      limit: limit || undefined,
      offset: offset || undefined,
      order: order || undefined
    },
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => (result.data || []).map(mapOcppIdTagAssignment))
}

function countOcppIdTagAssignments ({ transportationProfileId, search } = {}) {
  return apiRequests.get('/v1/ocpp-id-tag/profile-assignments/count', {
    params: {
      transportationProfileId: transportationProfileId || undefined,
      search: search || undefined
    },
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function assignOcppIdTagProfile ({ idTag, transportationProfileId, vehicleClass, notes }) {
  return apiRequests.post('/v1/ocpp-id-tag/assign', {
    idTag,
    transportationProfileId,
    vehicleClass,
    notes: notes || undefined
  }, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function deleteOcppIdTagAssignment ({ idTag, transportationProfileId }) {
  return apiRequests.delete('/v1/ocpp-id-tag/' + encodeURIComponent(idTag) + '/assignment', {
    params: {
      transportationProfileId
    },
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

export {
  listOcppIdTags,
  listOcppIdTagAssignments,
  countOcppIdTagAssignments,
  assignOcppIdTagProfile,
  deleteOcppIdTagAssignment
}
